export default __webpack_public_path__ + "static/media/mg-rebate-m.2f223311.webp";